import {
  Card,
  Divider,
  Grid,
  Stack,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { CompanyLink } from '../Layout/Public/Bio/Intro';

type CardWithChipAndDescProps = {
  obj?: any;
};

export const CardExperience = styled(Card)(({ theme }) => ({
  width: '100%',
  padding: 24,
  boxShadow:
    'rgba(162, 164, 165, 0.3) 0px 1px 2px 0px, rgba(163, 166, 168, 0.15) 0px 2px 6px 2px;',
  borderRadius: 24,
  backgroundColor: `${theme.palette.background.default}`,
}));

const CardWithChipAndDesc = ({ obj }: CardWithChipAndDescProps) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  // let style: any = {
  //   padding: isTablet ? 0 : 2,
  //   borderRight: isTablet ? 'none' : '2px solid #42A5F5',
  // };

  // if (!isTablet) {
  //   style = {
  //     ...style,
  //     ...centerStyle,
  //   };
  // }

  return (
    <CardExperience>
      <Grid container direction="row" spacing={4}>
        <Grid item xs={12} sm={12} md={3}>
          <Stack
            direction="column"
            justifyContent="space-between"
            spacing={1}
            sx={{
              my: 4,
              textAlign: isTablet ? 'center' : 'right',
              borderRight: isTablet ? 'none' : '3px solid #42A5F5',
              px: isTablet ? 0 : 4,
            }}
          >
            <Typography variant="h6" sx={{ mb: 1, fontWeight: '700' }}>
              {obj?.title}
            </Typography>
            {obj.company && (
              <Typography variant="body1" sx={{ m: 0 }}>
                <CompanyLink href={obj.companyLink} target="_blank">
                  @ {obj.company}
                </CompanyLink>
              </Typography>
            )}
            <Typography variant="h6">{obj?.period}</Typography>
            {obj.location && (
              <Typography variant="body2" sx={{ mt: 0 }}>
                - {obj?.location}
              </Typography>
            )}
          </Stack>
        </Grid>
        {isTablet && (
          <Divider
            sx={(theme) => ({
              borderColor: theme.palette.text.primary,
              marginY: 2,
              width: '100%',
              px: 4,
            })}
          />
        )}
        <Grid
          item
          xs={12}
          sm={12}
          md={9}
          style={{ textAlign: 'left', paddingLeft: '20px', margin: 'auto 0' }}
        >
          <Typography variant="body1" sx={{ mt: 1, mb: 2 }}>
            <DescriptionsList descriptions={obj?.descriptions} />
          </Typography>
        </Grid>
      </Grid>
    </CardExperience>
  );
};

const DescriptionsList = ({ descriptions }: { descriptions: string[] }) => {
  return (
    <ul
      style={{
        listStyleType: 'circle',
        paddingLeft: '20px',
        lineHeight: '1.8em',
      }}
    >
      {descriptions.map((desc, index) => (
        <li key={index} style={{ marginBottom: '8px', fontSize: '1.2rem' }}>
          {desc}
        </li>
      ))}
    </ul>
  );
};

export default CardWithChipAndDesc;
